import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  FaBolt,
  FaRobot,
  FaUsers,
  FaVideo,
  FaShieldAlt,
  FaMarkdown,
  FaStar,
  FaCheck,
  FaChevronDown,
  FaChevronUp,
  FaPaperPlane,
  FaLock,
  FaKey,
  FaDatabase,
  FaGithub,
  FaTwitter,
  FaLinkedin,
  FaDiscord,
} from "react-icons/fa";
import "./LandingTest.css";

const LandingTest = () => {
  const [scrolled, setScrolled] = useState(false);
  const [activeTab, setActiveTab] = useState("desktop");
  const [openFaq, setOpenFaq] = useState(null);
  const [joinedCommunities, setJoinedCommunities] = useState({
    dev: false,
    college: false,
    startup: false,
  });

  // Handle scroll detection for sticky navbar
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 40) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  const toggleCommunity = (key) => {
    setJoinedCommunities((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  return (
    <div className="lt-body">
      {/* 🌌 Neural Grid Background */}
      <div className="lt-neural-bg"></div>

      {/* 🧭 1. Navbar */}
      <nav className={`lt-navbar ${scrolled ? "scrolled" : ""}`}>
        <div className="lt-container lt-nav-content">
          <Link to="/test" className="lt-brand">
            <div className="lt-brand-icon">🇮🇳</div>
            <span>Bharat Connect</span>
          </Link>

          <ul className="lt-nav-links">
            <li className="lt-nav-link"><a href="#features">Features</a></li>
            <li className="lt-nav-link"><a href="#ai">AI</a></li>
            <li className="lt-nav-link"><a href="#communities">Communities</a></li>
            <li className="lt-nav-link"><a href="#developers">Developers</a></li>
            <li className="lt-nav-link"><Link to="/pricing">Pricing</Link></li>
          </ul>

          <div className="lt-nav-actions">
            <Link to="/login" className="lt-btn lt-btn-ghost">
              Login
            </Link>
            <Link to="/register" className="lt-btn lt-btn-primary">
              Start Free
            </Link>
          </div>
        </div>
      </nav>

      {/* 🚀 2. Hero Section */}
      <section className="lt-hero-section">
        <div className="lt-container lt-hero-grid">
          {/* Left Column */}
          <div className="lt-hero-left">
            <div className="lt-hero-badge">
              <FaBolt /> ✨ Next Generation Messaging
            </div>
            <h1 className="lt-hero-title">
              Bharat Connect <br />
              <span className="lt-gradient-text">Powered by Sampark AI</span>
            </h1>
            <p className="lt-hero-desc">
              India's modern messaging platform built for people, communities, and AI collaboration in real time.
            </p>
            <div className="lt-hero-buttons">
              <Link to="/register" className="lt-btn lt-btn-primary">
                Start Free <FaPaperPlane />
              </Link>
              <a href="#demo" className="lt-btn lt-btn-secondary">
                Live Demo
              </a>
            </div>

            <div className="lt-hero-social-proof">
              <div className="lt-stars">
                <FaStar /><FaStar /><FaStar /><FaStar /><FaStar />
              </div>
              <div className="lt-proof-text">
                <strong>10K+</strong> Active Users across India
              </div>
            </div>
          </div>

          {/* Right Column: Interactive Animated Desktop Window */}
          <div className="lt-hero-visual" id="demo">
            {/* 🛸 Floating AI Assistant Widget */}
            <div className="lt-floating-widget lt-widget-ai">
              <div style={{ display: "flex", alignItems: "center", gap: "8px", fontWeight: 700, color: "var(--lt-primary)", fontSize: "0.85rem" }}>
                <FaRobot /> Sampark AI Floating Assistant
              </div>
              <div style={{ fontSize: "0.75rem", color: "var(--lt-text-sub)", marginTop: "4px" }}>
                • Tasks • Weather • Code Review • Translation
              </div>
            </div>

            {/* 🖥️ Desktop Window Frame */}
            <div className="lt-mock-window">
              <div className="lt-mock-sidebar">
                <div className="lt-window-dots">
                  <div className="lt-dot red"></div>
                  <div className="lt-dot yellow"></div>
                  <div className="lt-dot green"></div>
                </div>

                <div className="lt-sidebar-section-title">Chats</div>
                <div className="lt-chat-item active">
                  <div className="lt-avatar-sm">P</div>
                  <span>Priya Sharma</span>
                </div>
                <div className="lt-chat-item">
                  <div className="lt-avatar-sm" style={{ background: "#10b981" }}>R</div>
                  <span>Rahul Kumar</span>
                </div>
                <div className="lt-chat-item">
                  <div className="lt-avatar-sm" style={{ background: "#f59e0b" }}>T</div>
                  <span>Team Innovators</span>
                </div>

                <div className="lt-sidebar-section-title" style={{ marginTop: "12px" }}>Communities</div>
                <div className="lt-chat-item">
                  <div className="lt-avatar-sm" style={{ background: "var(--lt-secondary)" }}>🇮🇳</div>
                  <span>Bharat Tech Club</span>
                </div>
              </div>

              <div className="lt-mock-main">
                <div style={{ fontSize: "0.85rem", fontWeight: 700, paddingBottom: "10px", borderBottom: "1px solid var(--lt-border)", display: "flex", justifyContent: "space-between" }}>
                  <span>Priya Sharma</span>
                  <span style={{ color: "var(--lt-primary)", fontSize: "0.75rem" }}>● Online</span>
                </div>

                <div className="lt-msg-stream">
                  <div className="lt-msg-bubble user">
                    Hi 👋 Can we summarize the project updates?
                  </div>
                  <div className="lt-msg-bubble user">
                    @SamparkAI summarize key points for today's release.
                  </div>
                  <div className="lt-msg-bubble ai">
                    <div style={{ fontWeight: 700, color: "var(--lt-primary)", fontSize: "0.75rem", marginBottom: "4px" }}>
                      🤖 Sampark AI Engine
                    </div>
                    <strong>Summary Ready:</strong>
                    <ul style={{ paddingLeft: "14px", margin: "4px 0 0" }}>
                      <li>Firebase OTP authentication deployed</li>
                      <li>Communities hub live with 22K members</li>
                      <li>Sub-100ms real-time chat sync operational</li>
                    </ul>
                  </div>
                </div>

                <div className="lt-mock-input">
                  <span>Type a message or @SamparkAI...</span>
                  <FaPaperPlane style={{ color: "var(--lt-primary)" }} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 📈 3. Live Statistics Section */}
      <section className="lt-stats-section">
        <div className="lt-container">
          <div className="lt-stats-grid">
            <div className="lt-stat-card">
              <div className="lt-stat-number">10K+</div>
              <div className="lt-stat-label">Active Users</div>
            </div>
            <div className="lt-stat-card">
              <div className="lt-stat-number">1M+</div>
              <div className="lt-stat-label">Messages Delivered</div>
            </div>
            <div className="lt-stat-card">
              <div className="lt-stat-number">99.9%</div>
              <div className="lt-stat-label">Platform Uptime</div>
            </div>
            <div className="lt-stat-card">
              <div className="lt-stat-number">24/7</div>
              <div className="lt-stat-label">AI Assistant Support</div>
            </div>
          </div>
        </div>
      </section>

      {/* ⚡ 4. Core Features Section */}
      <section className="lt-section" id="features">
        <div className="lt-container">
          <div className="lt-section-header">
            <span className="lt-section-tag">Core Features</span>
            <h2 className="lt-section-title">Everything You Need For Modern Communication</h2>
            <p className="lt-section-sub">
              Built from the ground up for high speed, rich intelligence, and seamless community networking.
            </p>
          </div>

          <div className="lt-features-grid">
            <div className="lt-feature-card">
              <div className="lt-feature-icon"><FaBolt /></div>
              <h3 className="lt-feature-title">Realtime Messaging</h3>
              <p className="lt-feature-text">
                Lightning-fast chat powered by Firebase Realtime Database with instant read receipts and typing indicators.
              </p>
            </div>

            <div className="lt-feature-card">
              <div className="lt-feature-icon"><FaRobot /></div>
              <h3 className="lt-feature-title">Sampark AI Suite</h3>
              <p className="lt-feature-text">
                Indian-aware AI assistant inside every conversation with a 10-message continuity context buffer.
              </p>
            </div>

            <div className="lt-feature-card">
              <div className="lt-feature-icon"><FaUsers /></div>
              <h3 className="lt-feature-title">Communities Hub</h3>
              <p className="lt-feature-text">
                Build and discover public & private groups with live membership synchronization.
              </p>
            </div>

            <div className="lt-feature-card">
              <div className="lt-feature-icon"><FaVideo /></div>
              <h3 className="lt-feature-title">Voice & Video</h3>
              <p className="lt-feature-text">
                High-definition peer-to-peer WebRTC calls (Coming soon to Bharat Connect Ecosystem).
              </p>
            </div>

            <div className="lt-feature-card">
              <div className="lt-feature-icon"><FaShieldAlt /></div>
              <h3 className="lt-feature-title">Secure Verification</h3>
              <p className="lt-feature-text">
                Multi-layer security with mandatory Email verification and biometric 2-Step identity assurance.
              </p>
            </div>

            <div className="lt-feature-card">
              <div className="lt-feature-icon"><FaMarkdown /></div>
              <h3 className="lt-feature-title">Markdown Support</h3>
              <p className="lt-feature-text">
                Rich text formatting, interactive checklists, and Prism syntax-highlighted code blocks.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 🧠 5. Sampark AI Showcase */}
      <section className="lt-section lt-ai-section" id="ai">
        <div className="lt-container">
          <div className="lt-ai-grid">
            <div className="lt-ai-illustration">
              <div className="lt-ai-demo-box">
                <div className="lt-ai-prompt">
                  &gt; @SamparkAI write a Python script to calculate Fibonacci sequence
                </div>
                <div className="lt-ai-response">
                  ```python<br />
                  def fibonacci(n):<br />
                  &nbsp;&nbsp;a, b = 0, 1<br />
                  &nbsp;&nbsp;for _ in range(n):<br />
                  &nbsp;&nbsp;&nbsp;&nbsp;yield a<br />
                  &nbsp;&nbsp;&nbsp;&nbsp;a, b = b, a + b<br />
                  <br />
                  print(list(fibonacci(10)))<br />
                  ```
                </div>
              </div>
            </div>

            <div className="lt-ai-content">
              <span className="lt-section-tag">Intelligence Platform</span>
              <h2 className="lt-section-title">Meet Sampark AI Assistant</h2>
              <p className="lt-section-sub">
                Your built-in intelligent companion designed for Indian contexts, workflows, and instant answers.
              </p>

              <ul className="lt-ai-checklist">
                <li className="lt-ai-check-item"><div className="lt-check-icon"><FaCheck /></div> Summarize chats</li>
                <li className="lt-ai-check-item"><div className="lt-check-icon"><FaCheck /></div> Multi-lingual translate</li>
                <li className="lt-ai-check-item"><div className="lt-check-icon"><FaCheck /></div> Generate & review code</li>
                <li className="lt-ai-check-item"><div className="lt-check-icon"><FaCheck /></div> Answer complex questions</li>
                <li className="lt-ai-check-item"><div className="lt-check-icon"><FaCheck /></div> Explain documents</li>
                <li className="lt-ai-check-item"><div className="lt-check-icon"><FaCheck /></div> Indian Context AI</li>
              </ul>

              <Link to="/SamparkAI" className="lt-btn lt-btn-primary">
                Try Sampark AI <FaRobot />
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* 🌐 6. Community Section */}
      <section className="lt-section" id="communities">
        <div className="lt-container">
          <div className="lt-section-header">
            <span className="lt-section-tag">Networks & Groups</span>
            <h2 className="lt-section-title">Explore Active Communities</h2>
            <p className="lt-section-sub">
              Join thousands of creators, developers, and students growing together on Bharat Connect.
            </p>
          </div>

          <div className="lt-comm-grid">
            <div className="lt-comm-card">
              <div className="lt-comm-avatar">💻</div>
              <h3 className="lt-comm-name">Developers Guild</h3>
              <p className="lt-comm-members">22K Members • Active</p>
              <button
                className={`lt-btn ${joinedCommunities.dev ? "lt-btn-secondary" : "lt-btn-primary"}`}
                onClick={() => toggleCommunity("dev")}
              >
                {joinedCommunities.dev ? "✓ Joined" : "Join Network"}
              </button>
            </div>

            <div className="lt-comm-card">
              <div className="lt-comm-avatar">🎓</div>
              <h3 className="lt-comm-name">College Hub India</h3>
              <p className="lt-comm-members">3K Members • Active</p>
              <button
                className={`lt-btn ${joinedCommunities.college ? "lt-btn-secondary" : "lt-btn-primary"}`}
                onClick={() => toggleCommunity("college")}
              >
                {joinedCommunities.college ? "✓ Joined" : "Join Network"}
              </button>
            </div>

            <div className="lt-comm-card">
              <div className="lt-comm-avatar">🚀</div>
              <h3 className="lt-comm-name">Startups & Founders</h3>
              <p className="lt-comm-members">12K Members • Active</p>
              <button
                className={`lt-btn ${joinedCommunities.startup ? "lt-btn-secondary" : "lt-btn-primary"}`}
                onClick={() => toggleCommunity("startup")}
              >
                {joinedCommunities.startup ? "✓ Joined" : "Join Network"}
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* 💬 7. Messaging Showcase */}
      <section className="lt-section">
        <div className="lt-container">
          <div className="lt-section-header">
            <span className="lt-section-tag">Desktop Fidelity</span>
            <h2 className="lt-section-title">WhatsApp Desktop V2 Interface</h2>
            <p className="lt-section-sub">
              Designed for speed, productivity, and distraction-free communication.
            </p>
          </div>

          <div className="lt-msg-preview-window">
            <div className="lt-msg-features-list">
              <div className="lt-pill">⚡ Instant Typing Indicators</div>
              <div className="lt-pill">✓✓ Blue Read Receipts</div>
              <div className="lt-pill">❤️ Live Emoji Reactions</div>
              <div className="lt-pill">📁 File & Media Sharing</div>
              <div className="lt-pill">📝 Markdown Syntax</div>
            </div>

            <div style={{ textAlign: "center", color: "var(--lt-text-sub)", fontSize: "0.95rem" }}>
              Experience smooth chat scrolling, pinned chats, unread counters, and instant sidebar navigation.
            </div>
          </div>
        </div>
      </section>

      {/* 🔒 8. Security & Privacy */}
      <section className="lt-section" style={{ background: "rgba(5, 12, 19, 0.6)" }}>
        <div className="lt-container">
          <div className="lt-section-header">
            <span className="lt-section-tag">Enterprise Security</span>
            <h2 className="lt-section-title">Built With Multi-Layer Protection</h2>
          </div>

          <div className="lt-sec-grid">
            <div className="lt-sec-card">
              <FaKey className="lt-sec-icon" />
              <h4 style={{ margin: "10px 0" }}>OTP Verification</h4>
              <p style={{ fontSize: "0.85rem", color: "var(--lt-text-sub)" }}>Firebase SMS Recaptcha 2-Factor Auth.</p>
            </div>

            <div className="lt-sec-card">
              <FaLock className="lt-sec-icon" />
              <h4 style={{ margin: "10px 0" }}>End-to-End Ready</h4>
              <p style={{ fontSize: "0.85rem", color: "var(--lt-text-sub)" }}>Encrypted data transport & privacy controls.</p>
            </div>

            <div className="lt-sec-card">
              <FaDatabase className="lt-sec-icon" />
              <h4 style={{ margin: "10px 0" }}>Encrypted Storage</h4>
              <p style={{ fontSize: "0.85rem", color: "var(--lt-text-sub)" }}>Strict Firebase security database rules.</p>
            </div>

            <div className="lt-sec-card">
              <FaShieldAlt className="lt-sec-icon" />
              <h4 style={{ margin: "10px 0" }}>Firebase Secure</h4>
              <p style={{ fontSize: "0.85rem", color: "var(--lt-text-sub)" }}>Backed by Google Cloud Infrastructure.</p>
            </div>
          </div>
        </div>
      </section>

      {/* 📸 9. Screenshots / Demo Tabs */}
      <section className="lt-section">
        <div className="lt-container">
          <div className="lt-section-header">
            <span className="lt-section-tag">Product Demo</span>
            <h2 className="lt-section-title">See Bharat Connect In Action</h2>
          </div>

          <div className="lt-tabs">
            <button className={`lt-tab-btn ${activeTab === "desktop" ? "active" : ""}`} onClick={() => setActiveTab("desktop")}>
              Desktop Chat
            </button>
            <button className={`lt-tab-btn ${activeTab === "mobile" ? "active" : ""}`} onClick={() => setActiveTab("mobile")}>
              Mobile View
            </button>
            <button className={`lt-tab-btn ${activeTab === "ai" ? "active" : ""}`} onClick={() => setActiveTab("ai")}>
              Sampark AI Portal
            </button>
            <button className={`lt-tab-btn ${activeTab === "comm" ? "active" : ""}`} onClick={() => setActiveTab("comm")}>
              Communities Hub
            </button>
          </div>

          <div className="lt-tab-display">
            {activeTab === "desktop" && (
              <div>
                <h3 style={{ marginBottom: "10px", color: "var(--lt-primary)" }}>Desktop View Mockup</h3>
                <p style={{ color: "var(--lt-text-sub)" }}>Full screen split-pane layout optimized for desktop productivity.</p>
              </div>
            )}
            {activeTab === "mobile" && (
              <div>
                <h3 style={{ marginBottom: "10px", color: "var(--lt-secondary)" }}>Mobile View Mockup</h3>
                <p style={{ color: "var(--lt-text-sub)" }}>Smooth overlay sidebar with responsive touch navigation.</p>
              </div>
            )}
            {activeTab === "ai" && (
              <div>
                <h3 style={{ marginBottom: "10px", color: "var(--lt-primary)" }}>Sampark AI Portal</h3>
                <p style={{ color: "var(--lt-text-sub)" }}>Dedicated AI chat portal with Neural Genesis background visualizer.</p>
              </div>
            )}
            {activeTab === "comm" && (
              <div>
                <h3 style={{ marginBottom: "10px", color: "var(--lt-accent)" }}>Communities Hub</h3>
                <p style={{ color: "var(--lt-text-sub)" }}>Live community creation modal & member directory.</p>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* ⭐ 10. Testimonials */}
      <section className="lt-section">
        <div className="lt-container">
          <div className="lt-section-header">
            <span className="lt-section-tag">Wall of Love</span>
            <h2 className="lt-section-title">Loved By Users Across India</h2>
          </div>

          <div className="lt-testi-grid">
            <div className="lt-testi-card">
              <div className="lt-stars" style={{ marginBottom: "12px" }}>
                <FaStar /><FaStar /><FaStar /><FaStar /><FaStar />
              </div>
              <p className="lt-testi-quote">
                "The best AI messaging app. Integrating Sampark AI directly into my group chats transformed how our engineering team works."
              </p>
              <div className="lt-testi-user">
                <div className="lt-testi-avatar">R</div>
                <div>
                  <strong>Rahul Kumar</strong>
                  <div style={{ fontSize: "0.8rem", color: "var(--lt-text-muted)" }}>Senior Software Engineer</div>
                </div>
              </div>
            </div>

            <div className="lt-testi-card">
              <div className="lt-stars" style={{ marginBottom: "12px" }}>
                <FaStar /><FaStar /><FaStar /><FaStar /><FaStar />
              </div>
              <p className="lt-testi-quote">
                "Super clean UI! It feels like WhatsApp Desktop V2 but with supercharged AI built right into the app."
              </p>
              <div className="lt-testi-user">
                <div className="lt-testi-avatar" style={{ background: "var(--lt-secondary)" }}>P</div>
                <div>
                  <strong>Priya Sharma</strong>
                  <div style={{ fontSize: "0.8rem", color: "var(--lt-text-muted)" }}>Product Designer</div>
                </div>
              </div>
            </div>

            <div className="lt-testi-card">
              <div className="lt-stars" style={{ marginBottom: "12px" }}>
                <FaStar /><FaStar /><FaStar /><FaStar /><FaStar />
              </div>
              <p className="lt-testi-quote">
                "The Communities feature made managing our 12K startup network seamless. Highly recommended!"
              </p>
              <div className="lt-testi-user">
                <div className="lt-testi-avatar" style={{ background: "var(--lt-accent)" }}>V</div>
                <div>
                  <strong>Vikram Patel</strong>
                  <div style={{ fontSize: "0.8rem", color: "var(--lt-text-muted)" }}>Community Founder</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ❓ 11. FAQ Section */}
      <section className="lt-section" id="developers">
        <div className="lt-container">
          <div className="lt-section-header">
            <span className="lt-section-tag">Got Questions?</span>
            <h2 className="lt-section-title">Frequently Asked Questions</h2>
          </div>

          <div className="lt-faq-container">
            {[
              { q: "How secure is Bharat Connect?", a: "Bharat Connect uses Firebase Security Rules, email verification, and 2-step SMS OTP verification to safeguard user accounts and data." },
              { q: "Does it support AI?", a: "Yes! Sampark AI is natively integrated. You can invoke @SamparkAI directly in any 1:1 chat or access the standalone /SamparkAI portal." },
              { q: "Can I create custom communities?", a: "Absolutely. Users can build both public and private communities, customize logos, and manage live member directories." },
              { q: "How does Phone OTP work?", a: "During registration and verification, an SMS verification code is dispatched via Firebase Phone Authentication with reCAPTCHA verification." },
              { q: "Is Bharat Connect free to use?", a: "Yes! Bharat Connect is free for all core messaging, community networking, and AI assistant features." },
            ].map((faq, idx) => (
              <div className="lt-faq-item" key={idx}>
                <div className="lt-faq-header" onClick={() => toggleFaq(idx)}>
                  <span>{faq.q}</span>
                  {openFaq === idx ? <FaChevronUp style={{ color: "var(--lt-primary)" }} /> : <FaChevronDown />}
                </div>
                {openFaq === idx && <div className="lt-faq-body">{faq.a}</div>}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 🏁 12. Final CTA */}
      <section className="lt-section">
        <div className="lt-container">
          <div className="lt-cta-card">
            <h2 className="lt-cta-title">
              Ready to Experience <br />
              Next Generation Messaging?
            </h2>
            <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
              <Link to="/register" className="lt-btn lt-btn-primary">
                Start Free Now <FaPaperPlane />
              </Link>
              <Link to="/login" className="lt-btn lt-btn-secondary">
                Sign In
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* 👣 13. Footer */}
      <footer className="lt-footer">
        <div className="lt-container">
          <div className="lt-footer-grid">
            <div className="lt-footer-col">
              <div className="lt-brand" style={{ marginBottom: "16px" }}>
                <div className="lt-brand-icon">🇮🇳</div>
                <span>Bharat Connect</span>
              </div>
              <p style={{ color: "var(--lt-text-sub)", fontSize: "0.9rem", maxWidth: "300px" }}>
                Connecting Bharat with intelligent real-time messaging & community collaboration.
              </p>
            </div>

            <div className="lt-footer-col">
              <h4>Product</h4>
              <ul className="lt-footer-links">
                <li><a href="#features">Features</a></li>
                <li><a href="#ai">Sampark AI</a></li>
                <li><a href="#communities">Communities</a></li>
                <li><Link to="/pricing">Pricing</Link></li>
              </ul>
            </div>

            <div className="lt-footer-col">
              <h4>Resources</h4>
              <ul className="lt-footer-links">
                <li><Link to="/docs">Documentation</Link></li>
                <li><Link to="/privacy">Privacy Policy</Link></li>
                <li><Link to="/terms">Terms of Service</Link></li>
                <li><Link to="/support">Support</Link></li>
              </ul>
            </div>

            <div className="lt-footer-col">
              <h4>Company</h4>
              <ul className="lt-footer-links">
                <li><a href="#about">About Us</a></li>
                <li><Link to="/version">Changelog</Link></li>
                <li><a href="#careers">Careers</a></li>
                <li><a href="#contact">Contact</a></li>
              </ul>
            </div>
          </div>

          <div className="lt-footer-bottom">
            <div>© 2026 Bharat Connect & Sampark AI. All rights reserved.</div>
            <div style={{ display: "flex", gap: "16px", fontSize: "1.2rem" }}>
              <FaGithub style={{ cursor: "pointer" }} />
              <FaTwitter style={{ cursor: "pointer" }} />
              <FaLinkedin style={{ cursor: "pointer" }} />
              <FaDiscord style={{ cursor: "pointer" }} />
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingTest;
